<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Netsuite ID
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="netsuiteId"
                  placeholder=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Author Type
              </td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="listAuthorType"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'authorType'"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Author Name</th>
          <th scope="col">Email Address</th>
          <th scope="col">Product ID</th>
          <th scope="col">Netsuite ID</th>
          <th scope="col">Contracted Date</th>
          <th scope="col">Publishing Date</th>
          <th scope="col">Country</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.author_name}}</td>
          <td>{{product.email_address}}</td>
          <td>{{product.part_number}}</td>
          <td>{{product.netsuite_internal_id}}</td>
          <td>{{product.contracted_date}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.alt_address_country}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
